import { Trans } from "@lingui/macro";
import { Stack } from "@mui/material";
import { IconButton } from "@WahooFitness/redesignr";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import { Info, X } from "@phosphor-icons/react";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { Link as ReactRouterLink } from "react-router-dom";

const WorkoutProfilesAlert = ({ onClose }: { onClose?: () => void }) => {
  return (
    <Box p={2}>
      <Alert
        severity="info"
        variant="filled"
        icon={<Info weight="fill" size={24} />}
        action={
          <IconButton onClick={onClose} color="info" variant="contained" size="medium">
            <X />
          </IconButton>
        }
      >
        <Stack>
          <Typography variant="prose-base-medium">
            <Trans>Heads up!</Trans>
          </Typography>
          <Typography variant="prose-sm">
            <Trans>
              Some Device Settings have been relocated to{" "}
              <Link to="/workout-profiles" component={ReactRouterLink}>
                Workout Profiles
              </Link>
              .
            </Trans>
          </Typography>
        </Stack>
      </Alert>
    </Box>
  );
};
export default WorkoutProfilesAlert;
